export const getSteps = (state) => state.steps